import React from 'react';
import Input from '~/components/Inputs/Input';
import InputMask from '~/components/Inputs/InputMask';
import InputCurrency from '~/components/Inputs/InputCurrency';
import { Row, Col, FormGroup, Label } from 'reactstrap';

export default function IndividualFields({
  disabled = false,
  disabledFields = {},
}) {
  const isDisabled = fieldName =>
    Boolean(disabledFields?.[fieldName] ?? disabled);

  return (
    <>
      <Row className="w-100 mx-0">
        <Col xs={12} lg={6} className="px-lg-0 pr-lg-2">
          <FormGroup className="mb-0">
            <Row className="mx-0">
              <Label>Nascimento</Label>
              <InputMask
                disabled={isDisabled('individual_birth_date')}
                name="individual_birth_date"
                placeholder="Data de Nascimento (dd/mm/aaaa)"
                mask="99/99/9999"
                maskChar={null}
                type="text"
              />
            </Row>
          </FormGroup>
        </Col>
        <Col xs={12} lg={6} className="px-lg-0 pl-lg-2">
          <FormGroup className="mb-0">
            <Label>Renda Mensal</Label>
            <InputCurrency
              disabled={isDisabled('monthly_income')}
              name="monthly_income"
              placeholder="Renda mensal (R$)"
              type="text"
              currency
            />
          </FormGroup>
        </Col>
      </Row>
      <Row className="w-100 mx-0 mt-3">
        <Col xs={12} lg={6} className="px-lg-0 pr-lg-2">
          <FormGroup className="mb-0">
            <Row className="mx-0">
              <Label>Ocupação Profissional</Label>
              <Input
                disabled={isDisabled('professional_occupation')}
                name="professional_occupation"
                placeholder="Ocupação profissional"
              />
            </Row>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}
